import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import departmentApi from '../api/rest/departmentApi';
import {modalCreateUpdateEmployeeStateSelector} from '../stores/selectors/manageEmployeeStateSelector';

const useDepartment = () => {
  const [departments, setDepartments] = useState([]);
  const {userAuthRoleId} = useSelector(modalCreateUpdateEmployeeStateSelector);
  useEffect(() => {
    (async () => {
      const res = await departmentApi.getAllDepartment(userAuthRoleId);
      if (res) {
        setDepartments(
          res.map((r) => ({
            ...r,
            id: r.id,
            text: r.departmentName,
            group: '',
          }))
        );
      }
    })();
  }, [userAuthRoleId]);

  return departments;
};

export default useDepartment;
